export const messages = {
  en: {
    addMenuView: {
      title: 'Configure Menu',
      menuName: 'Menu Name',
      menuNamePlaceholder: 'Required, please enter menu name',
      menuNameRequired: 'Menu name is required',
      menuUrl: 'Menu URL',
      menuUrlPlaceholder: 'Required, please enter menu URL',
      menuUrlRequired: 'Menu URL is required',
      seq: 'Sequence',
      seqPlaceholder: 'Required, please enter sequence',
      seqRequired: 'Sequence is required',
      menuShow: 'Menu Display',
      menuShowPlaceholder: 'Required, please select menu display',
      menuShowRequired: 'Menu display is required',
      showMenu: 'Show Menu',
      hideMenu: 'Hide Menu',
      description: 'Description',
      descriptionPlaceholder: 'Optional, please enter description'
    }
  },
  zh: {
    addMenuView: {
      title: '配置菜单',
      menuName: '菜单名称',
      menuNamePlaceholder: '必填，请填写菜单名称',
      menuNameRequired: '菜单名称不能为空',
      menuUrl: '菜单地址',
      menuUrlPlaceholder: '必填，请填写菜单地址',
      menuUrlRequired: '菜单地址不能为空',
      seq: '序列',
      seqPlaceholder: '必填，请填写序列',
      seqRequired: '序列不能为空',
      menuShow: '菜单显示',
      menuShowPlaceholder: '必填，请选择菜单显示',
      menuShowRequired: '菜单显示不能为空',
      showMenu: '显示菜单',
      hideMenu: '不显示菜单',
      description: '描述',
      descriptionPlaceholder: '选填，请填写描述'
    }
  }
}